import {mobileCatalogItem} from './mobile-catalog-navigation.mjs';
export const isPostArea=path=>['/feed','/group','/groups'].some(base=>path===base||path.startsWith(base+'/'));
export function mobileFeedItem(path){return isPostArea(path)
 ?{label:'Каталог',icon:'leaf',to:'/catalog',active:false}
 :{label:'Лента',icon:'feed',to:'/feed',active:path==='/questions'||path.startsWith('/questions/')};}
export function mobileContentSearchItem(path,catalogExpanded=false,postExpanded=false){return isPostArea(path)
 ?{label:'Поиск',icon:'search',action:'post-search',ariaLabel:'Поиск по постам',active:true,dialog:true,expanded:postExpanded}
 :mobileCatalogItem(path,catalogExpanded);}
